import { useSelector } from "react-redux";
import { Form } from "react-bootstrap";
import Select from "react-select";

import {
  MAIN_URL,
  PORT,
  API_ADD_STATEMENT_FILE_DOWNLOAD,
  API_DOWNLOAD_FILE_PROVISION_INFO,
  API_DOWNLOAD_FILE_MODIF,
  API_DOWNLOAD_FILE_TECH_EXAM,
} from "../../../../constants/constants";

import styles from "./appFooterCorrected.module.css";

export default function AppFooterCorrected({ inputData, mode, updateNewData, handleFile, errors }) {
  const downloadAPI = window.location.pathname.includes("provisioninformation")
    ? API_DOWNLOAD_FILE_PROVISION_INFO
    : API_DOWNLOAD_FILE_MODIF;

  const handleChange = (e) => {
    switch (true) {
      case e.target.id === "file":
        if (e.target.files[0]) {
          handleFile(e.target.files[0]);
        }
        break;
      default:
        if (e) {
          if (e.target) {
            updateNewData(e.target.id, e.target.value, e.target.type);
          }
        }
        break;
    }
  };

  const checkForExaminationResultAddModal = () => {
    return window.location.pathname.includes("checksAndAudits") && mode === "add";
  };

  const checkForExaminationResultViewModal = () => {
    return window.location.pathname.includes("checksAndAudits") && mode === "view";
  };

  const usersLibrary = useSelector((state) => {
    const { dictionaryReducer } = state;
    return dictionaryReducer.usersLibrary;
  });
  const userInfo = useSelector((state) => {
    const { dictionaryReducer } = state;
    return dictionaryReducer.userInfo;
  });

  return (
    <>
      {
        // Object.values(usersLibrary).length > 0 &&
        (Object.values(inputData).length > 0 || window.location.pathname.includes("checksAndAudits")) && (
          <div className={styles.content_container}>
            {((window.location.pathname.includes("techexamination") && mode === "add") ||
              (!window.location.pathname.includes("techexamination") && mode !== "view")) && (
              <Form.Group className={styles.header}>
                <Form.Label>
                  {checkForExaminationResultViewModal() || checkForExaminationResultAddModal
                    ? ""
                    : "Файл заявления"}
                </Form.Label>
                <Form.Control
                  id="file"
                  type="file"
                  accept=".doc,.docx,.pdf"
                  onChange={(e) => {
                    handleChange(e);
                  }}
                />
              </Form.Group>
            )}
            {inputData.fileType && (
              <div className={styles.file_area}>
                <p className="me-2">Файл заявления:</p>
                <a
                  href={`${MAIN_URL}${PORT}${API_ADD_STATEMENT_FILE_DOWNLOAD}${
                    inputData[inputData.fileType].docid
                  }`}>
                  {inputData[inputData.fileType].docname}
                </a>
              </div>
            )}
            {inputData.fileId && (
              <div className={styles.file_area}>
                <p className="me-2">Файл заявления:</p>
                <a href={`${MAIN_URL}${PORT}${downloadAPI}${inputData.fileId}`}>{inputData.fileName}</a>
              </div>
            )}
            {(inputData.fileDoc || inputData.filePdf) && (
              <div className={styles.file_area}>
                <a
                  target="_blank"
                  href={`${MAIN_URL}${PORT}${API_DOWNLOAD_FILE_TECH_EXAM}${
                    inputData.fileDoc || inputData.filePdf
                  }`}>
                  Файл заявления
                </a>
              </div>
            )}
            {inputData.appFileId && (
              <div className={styles.file_area}>
                <p className="me-2">Файл заявления:</p>
                <a href={`${MAIN_URL}${PORT}${API_ADD_STATEMENT_FILE_DOWNLOAD}${inputData.appFileId}`}>
                  {inputData.appFile.docname}
                </a>
              </div>
            )}

            {!checkForExaminationResultAddModal() && (
              <>
                <Form.Group className={styles["input-area"]}>
                  <label className={styles["label"]}>Количество листов</label>
                  <input
                    id="appSheetCnt"
                    className={styles["form-input"]}
                    value={inputData.appSheetCnt}
                    type="text"
                    placeholder={mode !== "view" && "Введите"}
                    readOnly={mode === "view"}
                    disabled={mode === "view" ? true : false}
                    onChange={(e) => {
                      handleChange(e);
                    }}
                  />
                </Form.Group>

                <Form.Group className={styles["input-area"]}>
                  <label className={styles["label"]}>
                    Дата подачи заявления {mode !== "view" && <span className={styles["red-dot"]}>*</span>}
                  </label>
                  <input
                    id="appDate"
                    className={`${styles["form-input"]} ${errors.appDate ? styles["error-border"] : ""}`}
                    value={
                      !!inputData.appDate
                        ? inputData.appDate.includes(".")
                          ? inputData.appDate.split(".").reverse().join("-")
                          : inputData.appDate
                        : null
                    }
                    type="date"
                    readOnly={mode === "view"}
                    disabled={mode === "view" ? true : false}
                    onChange={(e) => handleChange(e)}
                  />
                  {errors.appDate && <div style={{ color: "red" }}>{errors.appDate}</div>}
                </Form.Group>
                <div className={styles["text-block"]}>
                  <p className={styles["option-label"]}>{"Должностное лицо"}</p>
                  <p className={styles["option-value"]}>
                    {usersLibrary.find((elem) => elem.value === inputData?.inspector)?.name ||
                      usersLibrary.find((elem) => elem.value === userInfo?.userid)?.name}
                  </p>
                </div>
              </>
            )}
          </div>
        )
      }
    </>
  );
}
